// Global styles have been migrated to CSS in src/styles/shadcn-theme.css
// This component is kept for backwards compatibility

const GlobalStyles = () => null;

export default GlobalStyles;
